import Vue from "vue";
import Router from "vue-router";

import layout from "@/layout";






import login from "@/login/login";


import index from "@/index/index";
import odd_job_index from "@/index/odd_job_index";
import lw_index from "@/index/lw_index";
import lwbus_company from "@/index/lwbus_company";
import lwbus_city_company from "@/index/lwbus_city_company";
import company from "@/index/company";
import odd_company from "@/index/odd_company";
import rechargerecord from "@/index/rechargerecord";
import city from "@/index/city";
import odd_city from "@/index/odd_city";
import odd_data from "@/index/odd_data";
import xiangQing from "@/index/xiangQing";
import rader_agent_S from "@/index/rader_agent_S";
import rader_C from "@/index/rader_C";
import payXQ from "@/index/payXQ";
import line_ech from "@/index/line_ech";






import import_resume from "@/user_management/import_resume";
import update_resume from "@/user_management/update_resume";
import auit_resume from "@/user_management/auit_resume";
import oddJob_resume from "@/user_management/oddJob_resume";
import inquire_resume from "@/user_management/inquire_resume";
import add_user from "@/user_management/add_user";
import audit_video from "@/user_management/audit_video";
import photo_upload from "@/user_management/photo_upload";
import enterprise_photo_upload from "@/user_management/enterprise_photo_upload";
import video_upload from "@/user_management/video_upload";
import delete_resume from "@/user_management/delete_resume";
import change_psd from "@/user_management/change_psd";
import user_change from "@/user_management/user_change"; //24猎修改账号密码
// import user_change_vip from "@/user_management/user_change_vip"; //24猎修改会员到期时间
import high_salary from '@/user_management/high_salary' // 24猎高薪警告
import report from '@/user_management/report' // 24猎举报列表
import report_personnel from '@/user_management/report_personnel' // 24猎举报人员列表
import consulting_service from '@/user_management/consulting_service' // 24猎企业咨询
import position_review from '@/user_management/position_review' //24猎职位审核
import job_details from '@/user_management/job_details'
import details from '@/user_management/details'






import client from "@/sales_management/client";
import auit_detail from "@/sales_management/auit_detail";
import open_sea from "@/sales_management/open_sea";
import me_data from "@/sales_management/me_data";
import to_examine from "@/sales_management/to_examine";
import bill_of_lading from "@/sales_management/bill_of_lading";
import basics_job from "@/sales_management/basics_job";
import accounts_m from "@/sales_management/accounts_m";
import staff_setup from "@/sales_management/staff_setup";
import target_setting from "@/sales_management/target_setting";
import team_data from "@/sales_management/team_data";
import author from "@/sales_management/author";
import database from '@/sales_management/database'





import establish from "@/lwbus/establish";
import lw_change_ps from "@/lwbus/lw_change_ps";
// import CustomerManagement from '@/lwbus/customerManagement'  //劳务巴士》客户管理
import RegistrationList from "@/lwbus/RegistrationList"; //劳务巴士>  注册列表








import personnel_creation from "@/personnel/personnel_creation";
import personnel_modification from "@/personnel/personnel_modification";





import organizational_structure from "@/personnel_matters/organizational_structure";
import check_work_attendance from "@/personnel_matters/check_work_attendance";
import add_employee from "@/personnel_matters/add_employee";
import staff_management from "@/personnel_matters/staff_management";





//代理商管理
import er_hunting from "@/agentManagement/er_hunting"; //代理商管理——》24猎代理商
import pro_hunting from "@/agentManagement/pro_hunting"; //代理商管理——》24猎省代
import agentData from "@/agentManagement/agentData"; //24猎代理商
import agentData_value from "@/agentManagement/agentData_value"; //24猎代理商
import pro_agentValue from "@/agentManagement/pro_agentValue"; //24猎代理商省代详情
import recruitmentData from "@/agentManagement/recruitmentData"; //24猎代理商招聘数据看板



import personalCenter from "@/personalCenter/personalCenter"; //个人中心




// 猎零云管理
import create_lie from "@/lielingyun/create_lie"
import restore from "@/lielingyun/restore"
import hrs_customer from "@/lielingyun/hrs_customer"


//充值管理

import recharge_audit from "@/recharge_management/recharge_audit";
import prepaidCustomerBillOfLading from "@/recharge_management/prepaidCustomerBillOfLading";

//创建导航页面


// routerAuth 用于路由守卫，true 需要对路径进行验证，false不用
// meta:{
//  routerAuth:true
// }
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);
export default new Router({
  // mode: 'history',
  routes: [{
      path: "/",
      name: "login",
      component: login,
      meta: {
        routerAuth: false
      }
    },
    {
      path: "/layout",
      name: "layout",
      component: layout,
      children: [{
          path: "/index",
          name: "index",
          component: index,
          meta: {
            routerAuth: true
          }
        }, {
          path: "/odd_job_index",
          name: "odd_job_index",
          component: odd_job_index,
          meta: {
            routerAuth: true
          }
        }, {
          path: "/city",
          name: "city",
          component: city,
          meta: {
            routerAuth: true
          }
        }, {
          path: "/odd_city",
          name: "odd_city",
          component: odd_city,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/odd_data",
          name: "odd_data",
          component: odd_data,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/job_details",
          name: "job_details",
          component: job_details,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/details",
          name: "details",
          component: details,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/position_review",
          name: "position_review",
          component: position_review,
          meta: {
            routerAuth: true,
            keepAlive: true
          }
        },
        {
          path: "/audit_video",
          name: "audit_video",
          component: audit_video,
          meta: {
            routerAuth: true,
            keepAlive: true
          }
        },
        {
          path: "/rader_agent_S",
          name: "rader_agent_S",
          component: rader_agent_S,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/rader_C",
          name: "rader_C",
          component: rader_C,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/lw_index",
          name: "lw_index",
          component: lw_index,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/lwbus_company",
          name: "lwbus_company",
          component: lwbus_company,
          meta: {
            routerAuth: true
          }
        },{
          path: "/lwbus_city_company",
          name: "lwbus_city_company",
          component: lwbus_city_company,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/add_user",
          name: "add_user",
          component: add_user,
          meta: {
            routerAuth: true
          }
        },
        {
          //24猎的修改账号密码
          path: "/user_change",
          name: "user_change",
          component: user_change,
          meta: {
            routerAuth: true
          }
        },
        // {
        //   //24猎的修改会员到期时间
        //   path: "/user_change_vip",
        //   name: "user_change_vip",
        //   component: user_change_vip,
        //   meta: {
        //     routerAuth: true
        //   }
        // },
        {
          path: "/import_resume",
          name: "import_resume",
          component: import_resume,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/update_resume",
          name: "update_resume",
          component: update_resume,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/auit_resume",
          name: "auit_resume",
          component: auit_resume,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/oddJob_resume",
          name: "oddJob_resume",
          component: oddJob_resume,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/inquire_resume",
          name: "inquire_resume",
          component: inquire_resume,
          meta: {
            routerAuth: true
          }
        },

        {
          path: "/line_ech",
          name: "line_ech",
          component: line_ech,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/auit_detail",
          name: "auit_detail",
          component: auit_detail,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/photo_upload",
          name: "photo_upload",
          component: photo_upload,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/enterprise_photo_upload",
          name: "enterprise_photo_upload",
          component: enterprise_photo_upload,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/video_upload",
          name: "video_upload",
          component: video_upload,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/delete_resume",
          name: "delete_resume",
          component: delete_resume,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/company",
          name: "company",
          component: company,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/odd_company",
          name: "odd_company",
          component: odd_company,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/rechargerecord",
          name: "rechargerecord",
          component: rechargerecord,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/change_psd",
          name: "change_psd",
          component: change_psd,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/client",
          name: "client",
          component: client,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/open_sea",
          name: "open_sea",
          component: open_sea,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/me_data",
          name: "me_data",
          component: me_data,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/to_examine",
          name: "to_examine",
          component: to_examine,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/bill_of_lading",
          name: "bill_of_lading",
          component: bill_of_lading,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/basics_job",
          name: "basics_job",
          component: basics_job,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/accounts_m",
          name: "accounts_m",
          component: accounts_m,
          meta: {
            routerAuth: true
          }
        },

        {
          path: "/staff_setup",
          name: "staff_setup",
          component: staff_setup,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/target_setting",
          name: "target_setting",
          component: target_setting,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/establish",
          name: "establish",
          component: establish,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/lw_change_ps",
          name: "lw_change_ps",
          component: lw_change_ps,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/personnel_creation",
          name: "personnel_creation",
          component: personnel_creation,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/personnel_modification",
          name: "personnel_modification",
          component: personnel_modification,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/team_data",
          name: "team_data",
          component: team_data,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/recharge_audit",
          name: "recharge_audit",
          component: recharge_audit,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/prepaidCustomerBillOfLading",
          name: "prepaidCustomerBillOfLading",
          component: prepaidCustomerBillOfLading,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/check_work_attendance",
          name: "check_work_attendance",
          component: check_work_attendance,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/organizational_structure",
          name: "organizational_structure",
          component: organizational_structure,
          meta: {
            routerAuth: true,
            keepAlive: true
          }
        },
        {
          path: "/add_employee",
          name: "add_employee",
          component: add_employee,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/customer_management",
          name: "customer_management",
          component: RegistrationList,
          meta: {
            routerAuth: true
          }
        },

        {
          path: "/staff_management",
          name: "staff_management",
          component: staff_management,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/er_hunting",
          name: "er_hunting",
          component: er_hunting,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/pro_hunting",
          name: "pro_hunting",
          component: pro_hunting,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/agentData",
          name: "agentData",
          component: agentData,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/agentData_value",
          name: "agentData_value",
          component: agentData_value,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/high_salary",
          name: "high_salary",
          component: high_salary,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/report",
          name: "report",
          component: report,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/report_personnel",
          name: "report_personnel",
          component: report_personnel,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/consulting_service",
          name: "consulting_service",
          component: consulting_service,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/xiangQing",
          name: "xiangQing",
          component: xiangQing,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/pro_agentValue",
          name: "pro_agentValue",
          component: pro_agentValue,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/recruitmentData",
          name: "recruitmentData",
          component: recruitmentData,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/personalCenter",
          name: "personalCenter",
          component: personalCenter,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/payXQ",
          name: "payXQ",
          component: payXQ,
          meta: {
            routerAuth: true
          }
        },
        {
          path: "/database",
          name: "database",
          component: database,
          meta: {
            routerAuth: true
          }
        },

        // 猎零云

        {
          path: "/create_lie",
          name: "create_lie",
          component: create_lie,
          meta: {
            routerAuth: true
          }
        },
        // 还原密码
        {
          path: "/restore",
          name: "restore",
          component: restore,
          meta: {
            routerAuth: true
          }
        },
        // 客户管理
        {
          path: "/hrs_customer",
          name: "hrs_customer",
          component: hrs_customer,
          meta: {
            routerAuth: true
          }
        },
      ]
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js